import { render } from "./EmailPassword.vue?vue&type=template&id=68f7d904"
import script from "./EmailPassword.vue?vue&type=script&lang=js"
export * from "./EmailPassword.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__